<div class="bg-background text-on-surface font-body-md min-h-screen flex overflow-x-hidden">
  <nav
    class="hidden md:flex flex-col h-screen w-64 fixed left-0 top-0 bg-surface shadow-[0px_4px_20px_rgba(61,26,110,0.05)] border-r border-outline-variant/30 z-50"
    data-testid="sidebar-desktop"
  >
    <app-sidebar />
  </nav>

  <div class="flex-1 md:ml-64 flex flex-col min-h-screen min-w-0 overflow-x-hidden">
    <header class="bg-surface/80 backdrop-blur-md shadow-[0px_4px_20px_rgba(61,26,110,0.05)] sticky top-0 z-40">
      <app-header (menuToggle)="openDrawer()" />
    </header>

    <main class="flex-1 p-container-margin-mobile md:p-container-margin-desktop bg-background overflow-x-hidden min-w-0 pb-20 md:pb-container-margin-desktop">
      <router-outlet />
    </main>
  </div>

  <app-bottom-nav />
  <app-mobile-drawer [open]="isDrawerOpen()" (closed)="closeDrawer()" />
</div>
